import { StyledSkeleton } from './styled';

const StatisticsLoader = () => <StyledSkeleton variant="rectangular" />;

export default StatisticsLoader;
